import { Col, Row, Skeleton } from 'antd';

function MerchantDetailsSkeleton() {
  return (
    <Row
      gutter={[16, 16]}
      style={{
        boxShadow: 'rgb(0 0 0 / 6%) 0px 3px 6px 4px',
        borderRadius: '10px',
        backgroundColor: 'white'
      }}
    >
      <Col span={24}>
        <Skeleton
          active
          paragraph={{
            rows: 0
          }}
        />
      </Col>
      <Col span={12}>
        <Skeleton
          active
          paragraph={{
            rows: 3
          }}
        />
      </Col>
      <Col span={12}>
        <Skeleton
          active
          paragraph={{
            rows: 4
          }}
        />
      </Col>
    </Row>
  );
}

export default MerchantDetailsSkeleton;
